import { defineMessages } from 'react-intl';

export const imageGalleryColorDialogMessages = defineMessages({
  selectColor: {
    id: 'imagegallery.colorPickerDialog.selectColor',
    defaultMessage: 'Farbe wählen',
  },
});
